import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#032E32",
      d: "M20.793 16.244c-.52-.896-1.294-3.432-1.294-6.744a7.5 7.5 0 0 0-15 0c0 3.313-.774 5.848-1.295 6.744A1.5 1.5 0 0 0 4.5 18.5h3.826a3.75 3.75 0 0 0 7.348 0h3.826a1.5 1.5 0 0 0 1.294-2.256ZM4.499 17c.722-1.241 1.5-4.117 1.5-7.5a6 6 0 1 1 12 0c0 3.38.776 6.256 1.5 7.5h-15Z"
    }, null, -1)
  ]))]))
}
export default { render: render }